import React from 'react'
import { RemoteComponent } from '@contrast-security-inc/design-system-foundations'

const RemoteSCMConfigurationPage = React.lazy(
  // @ts-ignore
  () => import('platformRepositories/SCMConfigurationPage')
)

export const SCMConfigurationPage = () => (
  <RemoteComponent>
    <RemoteSCMConfigurationPage />
  </RemoteComponent>
)
